// wholesaler-update-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Wholesaler } from 'src/app/interfaces/Wholesaler.interface';

export interface WholesalerDialogData {
  wholesalers: Wholesaler[];
  currentWholesalerEmail?: string | null;
  futureWholesalerEmail?: string | null;
}

@Component({
  selector: 'app-wholesaler-update-dialog',
  templateUrl: './wholesaler-update-dialog.component.html',
  styleUrls: ['./wholesaler-update-dialog.component.scss'],
  standalone: false,
})
export class WholesalerUpdateDialogComponent {
  selectedWholesalerEmail: string | null;
  confirmAcknowledge = false;

  constructor(
    public dialogRef: MatDialogRef<WholesalerUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WholesalerDialogData
  ) {
    // preselect current wholesaler if provided
    this.selectedWholesalerEmail = data.currentWholesalerEmail ?? null;
  }

  get selectedWholesaler(): Wholesaler | null {
    if (!this.selectedWholesalerEmail) return null;
    return (
      this.data.wholesalers.find(
        (w) => w.userEmail === this.selectedWholesalerEmail
      ) ?? null
    );
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onUpdate(): void {
    if (!this.selectedWholesalerEmail) {
      return;
    }
    // Only prevent update if selecting current AND there's no future wholesaler to cancel
    if (this.selectedWholesalerEmail === this.data.currentWholesalerEmail && !this.data.futureWholesalerEmail) {
      return;
    }
    this.dialogRef.close({
      action: 'update',
      wholesalerEmail: this.selectedWholesalerEmail,
    });
  }

  isUpdateDisabled(): boolean {
    if (!this.selectedWholesalerEmail) {
      return true;
    }
    // Only disable if selecting current wholesaler AND there's no future change to cancel
    // If there IS a future wholesaler, allow selecting current (to cancel the future change)
    return this.selectedWholesalerEmail === this.data.currentWholesalerEmail && !this.data.futureWholesalerEmail;
  }
}
